// ==========================================================================
// Order
// ==========================================================================
/* jshint esnext: true */
import { APP_NAME, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Example';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        this.$el.on(EVENT.CLICK, '.js-order-next', () => this.orderNext());
        this.$el.on(EVENT.CLICK, '.js-order-back', () => this.orderBack());
    }

    orderNext() {
        this.$el.addClass('is-next');

        $('html, body').animate({ scrollTop: 0 }, 300);

        $('.js-scroll').triggerHandler({
            type: 'scrollTo.LocomotiveScroll',
            options: {
                targetElem: 0,
                targetOffset: 0,
                speed: 300,
            }
        })
    }

    orderBack() {
        this.$el.removeClass('is-next');

        $('html, body').animate({ scrollTop: 0 }, 300);

        $('.js-scroll').triggerHandler({
            type: 'scrollTo.LocomotiveScroll',
            options: {
                targetElem: 0,
                targetOffset: 0,
                speed: 300,
            }
        })
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
